__turbopack_context__.v({
  "badge": "AlignmentChecker-module__ybE5zq__badge",
  "banner": "AlignmentChecker-module__ybE5zq__banner",
  "closeButton": "AlignmentChecker-module__ybE5zq__closeButton",
  "contextItem": "AlignmentChecker-module__ybE5zq__contextItem",
  "contextLabel": "AlignmentChecker-module__ybE5zq__contextLabel",
  "contextStrip": "AlignmentChecker-module__ybE5zq__contextStrip",
  "contextValue": "AlignmentChecker-module__ybE5zq__contextValue",
  "contextValueDim": "AlignmentChecker-module__ybE5zq__contextValueDim",
  "devBadge": "AlignmentChecker-module__ybE5zq__devBadge",
  "devBadgeIcon": "AlignmentChecker-module__ybE5zq__devBadgeIcon",
  "devBadgeLink": "AlignmentChecker-module__ybE5zq__devBadgeLink",
  "devBadgeToggle": "AlignmentChecker-module__ybE5zq__devBadgeToggle",
  "devBadgeToggleState": "AlignmentChecker-module__ybE5zq__devBadgeToggleState",
  "header": "AlignmentChecker-module__ybE5zq__header",
  "hint": "AlignmentChecker-module__ybE5zq__hint",
  "iadminMenu": "AlignmentChecker-module__ybE5zq__iadminMenu",
  "iadminMenuLink": "AlignmentChecker-module__ybE5zq__iadminMenuLink",
  "iadminMenuLinkIcon": "AlignmentChecker-module__ybE5zq__iadminMenuLinkIcon",
  "iadminMenuPanel": "AlignmentChecker-module__ybE5zq__iadminMenuPanel",
  "iadminMenuSection": "AlignmentChecker-module__ybE5zq__iadminMenuSection",
  "iadminMenuSectionTitle": "AlignmentChecker-module__ybE5zq__iadminMenuSectionTitle",
  "iadminMenuTrigger": "AlignmentChecker-module__ybE5zq__iadminMenuTrigger",
  "icon": "AlignmentChecker-module__ybE5zq__icon",
  "item": "AlignmentChecker-module__ybE5zq__item",
  "itemDocsLink": "AlignmentChecker-module__ybE5zq__itemDocsLink",
  "itemHead": "AlignmentChecker-module__ybE5zq__itemHead",
  "list": "AlignmentChecker-module__ybE5zq__list",
  "message": "AlignmentChecker-module__ybE5zq__message",
  "okMessage": "AlignmentChecker-module__ybE5zq__okMessage",
  "subtitle": "AlignmentChecker-module__ybE5zq__subtitle",
  "title": "AlignmentChecker-module__ybE5zq__title",
});
